module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/General/Half-heart-43cb34f2f55596f46299184d59f5e45d.svg";